import { render, staticRenderFns } from "./RegisterApplicantForm.vue?vue&type=template&id=2de93957&scoped=true"
import script from "./RegisterApplicantForm.vue?vue&type=script&lang=ts"
export * from "./RegisterApplicantForm.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RegisterApplicantForm.vue?vue&type=style&index=1&id=2de93957&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de93957",
  null
  
)

export default component.exports